var _rect, _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowsRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1464 -984C-1464 -985.105 -1463.1 -986 -1462 -986H6734C6735.1 -986 6736 -985.105 6736 -984V2137C6736 2138.1 6735.1 2139 6734 2139H-1462C-1463.1 2139 -1464 2138.1 -1464 2137V-984Z",
    fill: "#6A62B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1462 -985H6734V-987H-1462V-985ZM6735 -984V2137H6737V-984H6735ZM6734 2138H-1462V2140H6734V2138ZM-1463 2137V-984H-1465V2137H-1463ZM-1462 2138C-1462.55 2138 -1463 2137.55 -1463 2137H-1465C-1465 2138.66 -1463.66 2140 -1462 2140V2138ZM6735 2137C6735 2137.55 6734.55 2138 6734 2138V2140C6735.66 2140 6737 2138.66 6737 2137H6735ZM6734 -985C6734.55 -985 6735 -984.552 6735 -984H6737C6737 -985.657 6735.66 -987 6734 -987V-985ZM-1462 -987C-1463.66 -987 -1465 -985.657 -1465 -984H-1463C-1463 -984.552 -1462.55 -985 -1462 -985V-987Z",
    fill: "black",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_756)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 2573,
    transform: "translate(-1264 -786)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 27.5,
    stroke: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7071 28.7071C41.0976 28.3166 41.0976 27.6834 40.7071 27.2929L34.3431 20.9289C33.9526 20.5384 33.3195 20.5384 32.9289 20.9289C32.5384 21.3195 32.5384 21.9526 32.9289 22.3431L38.5858 28L32.9289 33.6569C32.5384 34.0474 32.5384 34.6805 32.9289 35.0711C33.3195 35.4616 33.9526 35.4616 34.3431 35.0711L40.7071 28.7071ZM16 29H40V27H16V29Z",
    fill: "#141414"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_756"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 2573,
    fill: "white",
    transform: "translate(-1264 -786)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsRight);
export default __webpack_public_path__ + "static/media/arrows-right.8d65f1e76c4082112ff16eb5e9e035b9.svg";
export { ForwardRef as ReactComponent };